import type { BootstrapData } from './types'

declare global {
  interface Window {
    __NEARMETAL__?: BootstrapData
  }
}

export function getBootstrap(): BootstrapData {
  if (window.__NEARMETAL__) return window.__NEARMETAL__
  const script = document.querySelector<HTMLScriptElement>('#__NEARMETAL_DATA__')
  if (!script?.textContent) throw new Error('NearMetal bootstrap data is missing')
  const data = JSON.parse(script.textContent) as BootstrapData
  window.__NEARMETAL__ = data
  return data
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      'content-type': 'application/json',
      ...init?.headers,
    },
  })
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { error?: string } | null
    throw new Error(body?.error ?? `Request failed with ${response.status}`)
  }
  return response.json() as Promise<T>
}
